import React, { ChangeEvent, useState, MouseEvent } from 'react';
import { ISpeakerRole } from './types';
import { useAppDispatch } from '../../../redux/store';
import { cloneDeep } from 'lodash';
import { SpeakerModalStage } from '../../../redux/store/IStore';

import { addSpeaker } from '../../../api/speakersService';
import Add from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { updateSpeakerModal } from '../../../redux/features/app/app';
import { useSnackbar } from 'notistack';
import { Tooltip } from '@mui/material';
import SpeakerRoles from '../SpeakerRoles';

const SpeakerModalCreate = () => {
  const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [speakerLabel, setSpeakerLabel] = useState<string>('');
  const [speakerRole, setSpeakerRole] = useState<string>('');
  const [speakerRoles, setSpeakerRoles] = useState<ISpeakerRole[]>([]);

  const updateSpeakerLabel = (event: ChangeEvent<HTMLInputElement>) => setSpeakerLabel(event.target.value);
  const updateSpeakerRole = (event: ChangeEvent<HTMLInputElement>) => setSpeakerRole(event.target.value);

  const addSpeakerRole = () =>
    setSpeakerRoles((current) => {
      if (speakerRole.length < 1) return current;

      current.push({ label: speakerRole, default: current.length === 0 });
      setSpeakerRole('');

      return current;
    });

  const changeDefaultRole = (index: number) => {
    const copy = cloneDeep(speakerRoles);
    copy.forEach((role, iterationIndex) => (role.default = iterationIndex === index));
    setSpeakerRoles(copy);
  };

  const deleteRole = (event: MouseEvent, index: number) => {
    event.preventDefault();
    event.stopPropagation();
    const copy = cloneDeep(speakerRoles);
    const isDeletedDefault = copy[index].default;

    copy.splice(index, 1);
    if (isDeletedDefault && copy.length > 0) {
      copy[0].default = true;
    }

    setSpeakerRoles(copy);
  };

  const cancelSpeakerCreate = () => dispatch(updateSpeakerModal({ modalStage: SpeakerModalStage.list }));

  const addSpeakerWrapper = async () => {
    const roles = speakerRoles.sort((a, b) => Number(b.default) - Number(a.default)).map((role) => role.label);
    try {
      await addSpeaker({
        name: speakerLabel,
        roles,
        updateLastSelectedAt: false,
      });
      dispatch(updateSpeakerModal({ modalStage: SpeakerModalStage.list }));
    } catch (error) {
      console.log(error);
      if ((error as any).response.status === 409) {
        enqueueSnackbar('Govorec s tem imenom že obstaja', { variant: 'error' });
      }
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
      <div>
        <div id="speaker_modal_header_wrapper">
          <p id="speaker_modal_header_title">Dodaj govorca</p>
        </div>
        <input
          className="add_user_input"
          value={speakerLabel}
          placeholder="Vnesite ime..."
          onChange={updateSpeakerLabel}
        />
        <div id="speaker_modal_role_input_container">
          <input
            className="add_user_input"
            id="speaker_modal_role_input"
            value={speakerRole}
            placeholder="Vnesite vlogo..."
            onChange={updateSpeakerRole}
          />
          <Tooltip title="Dodaj vlogo" disableInteractive arrow>
            <button onClick={addSpeakerRole}>
              <Add sx={{ color: '#2b8dff' }} />
            </button>
          </Tooltip>
        </div>
        <SpeakerRoles speakerRoles={speakerRoles} changeDefaultRole={changeDefaultRole} deleteRole={deleteRole} />
      </div>
      <div id="speaker_modal_footer">
        <button id="spekaer_modal_close_button" onClick={cancelSpeakerCreate}>
          NAZAJ
        </button>
        <button id="spekaer_modal_save_button" onClick={addSpeakerWrapper}>
          DODAJ
        </button>
      </div>
    </div>
  );
};

export default SpeakerModalCreate;
